function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerPortrait19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185.8 -139.41)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.8,
    y: 139.41,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "#b3a995",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.47 171.15a8.6548 8.6548 0 0 0-4.3475 1.1591 8.6548 8.6548 0 0 0-3.6499 4.1393h15.955a8.6548 8.6548 0 0 0-3.6499-4.1393 8.6548 8.6548 0 0 0-4.3078-1.1591z",
    fill: "#4f4b41",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.46 159.31c-1.0775 1.2294-1.8986 2.6133-2.7316 4.0091h-4.6817c-0.74304-1.453-1.7416-2.7166-2.7284-4.0049-2.014 2.7949-2.7347 5.8267-2.7347 8.6584-0.0693 3.9118 3.6579 6.2611 6.5717 6.3484h2.4675c4.3776-1.0077 6.5712-2.7058 6.5712-6.3484-0.0174-2.91-1.2445-6.6889-2.734-8.6625z",
    fill: "#4f4b41",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.14 97.512)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.678 40.587)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.32,
    cy: 29.469,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.3,
    cy: 29.478,
    rx: 0.77269,
    ry: 1.1024,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.39,
    cy: 29.469,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.37,
    cy: 29.478,
    rx: 0.77269,
    ry: 1.1024,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait19);
export default __webpack_public_path__ + "static/media/player-portrait-19.a91626ccf621963c64030c61fb029d69.svg";
export { ForwardRef as ReactComponent };